!(function (t, i) {
  "object" == typeof exports && "undefined" != typeof module
    ? i(exports)
    : "function" == typeof define && define.amd
    ? define(["exports"], i)
    : i(
        ((t =
          "undefined" != typeof globalThis ? globalThis : t || self).countUp =
          {})
      );
})(this, function (t) {
  "use strict";
  var i = function () {
      return (
        (i =
          Object.assign ||
          function (t) {
            for (var i, n = 1, s = arguments.length; n < s; n++)
              for (var e in (i = arguments[n]))
                Object.prototype.hasOwnProperty.call(i, e) && (t[e] = i[e]);
            return t;
          }),
        i.apply(this, arguments)
      );
    },
    n = (function () {
      function t(t, n, s) {
        var e = this;
        (this.endVal = n),
          (this.options = s),
          (this.version = "2.8.0"),
          (this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1,
          }),
          (this.finalEndVal = null),
          (this.useEasing = !0),
          (this.countDown = !1),
          (this.error = ""),
          (this.startVal = 0),
          (this.paused = !0),
          (this.once = !1),
          (this.count = function (t) {
            e.startTime || (e.startTime = t);
            var i = t - e.startTime;
            (e.remaining = e.duration - i),
              e.useEasing
                ? e.countDown
                  ? (e.frameVal =
                      e.startVal -
                      e.easingFn(i, 0, e.startVal - e.endVal, e.duration))
                  : (e.frameVal = e.easingFn(
                      i,
                      e.startVal,
                      e.endVal - e.startVal,
                      e.duration
                    ))
                : (e.frameVal =
                    e.startVal + (e.endVal - e.startVal) * (i / e.duration));
            var n = e.countDown ? e.frameVal < e.endVal : e.frameVal > e.endVal;
            (e.frameVal = n ? e.endVal : e.frameVal),
              (e.frameVal = Number(
                e.frameVal.toFixed(e.options.decimalPlaces)
              )),
              e.printValue(e.frameVal),
              i < e.duration
                ? (e.rAF = requestAnimationFrame(e.count))
                : null !== e.finalEndVal
                ? e.update(e.finalEndVal)
                : e.options.onCompleteCallback &&
                  e.options.onCompleteCallback();
          }),
          (this.formatNumber = function (t) {
            var i,
              n,
              s,
              a,
              o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(e.options.decimalPlaces);
            var r = (i += "").split(".");
            if (
              ((n = r[0]),
              (s = r.length > 1 ? e.options.decimal + r[1] : ""),
              e.options.useGrouping)
            ) {
              a = "";
              for (var l = 3, u = 0, h = 0, p = n.length; h < p; ++h)
                e.options.useIndianSeparators && 4 === h && ((l = 2), (u = 1)),
                  0 !== h && u % l == 0 && (a = e.options.separator + a),
                  u++,
                  (a = n[p - h - 1] + a);
              n = a;
            }
            return (
              e.options.numerals &&
                e.options.numerals.length &&
                ((n = n.replace(/[0-9]/g, function (t) {
                  return e.options.numerals[+t];
                })),
                (s = s.replace(/[0-9]/g, function (t) {
                  return e.options.numerals[+t];
                }))),
              o + e.options.prefix + n + s + e.options.suffix
            );
          }),
          (this.easeOutExpo = function (t, i, n, s) {
            return (n * (1 - Math.pow(2, (-10 * t) / s)) * 1024) / 1023 + i;
          }),
          (this.options = i(i({}, this.defaults), s)),
          (this.formattingFn = this.options.formattingFn
            ? this.options.formattingFn
            : this.formatNumber),
          (this.easingFn = this.options.easingFn
            ? this.options.easingFn
            : this.easeOutExpo),
          (this.startVal = this.validateValue(this.options.startVal)),
          (this.frameVal = this.startVal),
          (this.endVal = this.validateValue(n)),
          (this.options.decimalPlaces = Math.max(this.options.decimalPlaces)),
          this.resetDuration(),
          (this.options.separator = String(this.options.separator)),
          (this.useEasing = this.options.useEasing),
          "" === this.options.separator && (this.options.useGrouping = !1),
          (this.el = "string" == typeof t ? document.getElementById(t) : t),
          this.el
            ? this.printValue(this.startVal)
            : (this.error = "[CountUp] target is null or undefined"),
          "undefined" != typeof window &&
            this.options.enableScrollSpy &&
            (this.error
              ? console.error(this.error, t)
              : ((window.onScrollFns = window.onScrollFns || []),
                window.onScrollFns.push(function () {
                  return e.handleScroll(e);
                }),
                (window.onscroll = function () {
                  window.onScrollFns.forEach(function (t) {
                    return t();
                  });
                }),
                this.handleScroll(this)));
      }
      return (
        (t.prototype.handleScroll = function (t) {
          if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY,
              n = t.el.getBoundingClientRect(),
              s = n.top + window.pageYOffset,
              e = n.top + n.height + window.pageYOffset;
            e < i && e > window.scrollY && t.paused
              ? ((t.paused = !1),
                setTimeout(function () {
                  return t.start();
                }, t.options.scrollSpyDelay),
                t.options.scrollSpyOnce && (t.once = !0))
              : (window.scrollY > e || s > i) && !t.paused && t.reset();
          }
        }),
        (t.prototype.determineDirectionAndSmartEasing = function () {
          var t = this.finalEndVal ? this.finalEndVal : this.endVal;
          this.countDown = this.startVal > t;
          var i = t - this.startVal;
          if (
            Math.abs(i) > this.options.smartEasingThreshold &&
            this.options.useEasing
          ) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            (this.endVal = t + n * this.options.smartEasingAmount),
              (this.duration = this.duration / 2);
          } else (this.endVal = t), (this.finalEndVal = null);
          null !== this.finalEndVal
            ? (this.useEasing = !1)
            : (this.useEasing = this.options.useEasing);
        }),
        (t.prototype.start = function (t) {
          this.error ||
            (this.options.onStartCallback && this.options.onStartCallback(),
            t && (this.options.onCompleteCallback = t),
            this.duration > 0
              ? (this.determineDirectionAndSmartEasing(),
                (this.paused = !1),
                (this.rAF = requestAnimationFrame(this.count)))
              : this.printValue(this.endVal));
        }),
        (t.prototype.pauseResume = function () {
          this.paused
            ? ((this.startTime = null),
              (this.duration = this.remaining),
              (this.startVal = this.frameVal),
              this.determineDirectionAndSmartEasing(),
              (this.rAF = requestAnimationFrame(this.count)))
            : cancelAnimationFrame(this.rAF),
            (this.paused = !this.paused);
        }),
        (t.prototype.reset = function () {
          cancelAnimationFrame(this.rAF),
            (this.paused = !0),
            this.resetDuration(),
            (this.startVal = this.validateValue(this.options.startVal)),
            (this.frameVal = this.startVal),
            this.printValue(this.startVal);
        }),
        (t.prototype.update = function (t) {
          cancelAnimationFrame(this.rAF),
            (this.startTime = null),
            (this.endVal = this.validateValue(t)),
            this.endVal !== this.frameVal &&
              ((this.startVal = this.frameVal),
              null == this.finalEndVal && this.resetDuration(),
              (this.finalEndVal = null),
              this.determineDirectionAndSmartEasing(),
              (this.rAF = requestAnimationFrame(this.count)));
        }),
        (t.prototype.printValue = function (t) {
          var i;
          if (this.el) {
            var n = this.formattingFn(t);
            if (
              null === (i = this.options.plugin) || void 0 === i
                ? void 0
                : i.render
            )
              this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else
              "text" === this.el.tagName || "tspan" === this.el.tagName
                ? (this.el.textContent = n)
                : (this.el.innerHTML = n);
          }
        }),
        (t.prototype.ensureNumber = function (t) {
          return "number" == typeof t && !isNaN(t);
        }),
        (t.prototype.validateValue = function (t) {
          var i = Number(t);
          return this.ensureNumber(i)
            ? i
            : ((this.error = "[CountUp] invalid start or end value: ".concat(
                t
              )),
              null);
        }),
        (t.prototype.resetDuration = function () {
          (this.startTime = null),
            (this.duration = 1e3 * Number(this.options.duration)),
            (this.remaining = this.duration);
        }),
        t
      );
    })();
  (t.CountUp = n), Object.defineProperty(t, "__esModule", { value: !0 });
});

class ArticleLinks extends HTMLElement {
  constructor() {
    super();
    console.log("article-links.js loaded!");
  }

  connectedCallback() {
    const article = document.querySelector(".article__content");
    const h2Elements = article.querySelectorAll("h2");
    const wrapper = this.querySelector("ul");

    h2Elements.forEach((h2, index) => {
      // Add an id to the h2 element
      const id = `jump-link-target-${index}`;
      h2.setAttribute("id", id);

      const li = document.createElement("li");

      // Create a link to the h2 element
      const link = document.createElement("a");
      link.setAttribute("href", `#${id}`);
      link.textContent = h2.textContent;

      // Add the link to the wrapper
      li.appendChild(link);
      wrapper.appendChild(li);
    });

    if (wrapper.children.length > 0) {
      this.style.display = "block";
    }

    const links = wrapper.querySelectorAll("a");

    links.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();

        const target = document.querySelector(link.getAttribute("href"));
        target.scrollIntoView({ block: "start", behavior: "smooth" });
      });
    });
  }
}

// Define the new element
customElements.define("article-links", ArticleLinks);

class CountNumber extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animateNumber();
        }
      });
    };

    let observerOptions = {
      threshold: 0.7,
    };

    let observer = new IntersectionObserver(callback, observerOptions);

    observer.observe(this);
  }

  animateNumber() {
    const number = this.dataset.number;
    const suffix = this.dataset.suffix;
    const numAnim = new countUp.CountUp(this, number, {
      duration: 4,
      suffix: suffix,
    });
    if (!numAnim.error) {
      numAnim.start();
    } else {
      console.error(numAnim.error);
    }
  }
}

// Define the new element
customElements.define("count-number", CountNumber);

document.addEventListener("DOMContentLoaded", function () {
  let goToTopButton = document.querySelector(".go-to-top");
  goToTopButton.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});

class GalleryVideo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let buttonBlock = this;
    let button = this.querySelector(".gallery__play-button");
    let videoWrapper = this.querySelector(".gallery__video-wrapper");
    let video = this.querySelector(".gallery__video");
    let figure = this.querySelector(".gallery__figure");
    let figureHeight = figure.offsetHeight;

    video.style.height = `${figureHeight}px`;

    buttonBlock.addEventListener("click", () => {
      if (!buttonBlock.classList.contains("gallery__video--active")) {
        buttonBlock.classList.add("gallery__video--active");
        videoWrapper.style.display = "block";
        button.style.display = "none";
        figure.style.display = "none";

        video.play();
      }
    });
  }
}

// Define the new element
customElements.define("gallery-video", GalleryVideo);

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("og-cart-updated", (ev) => {
    console.log("og-cart-updated");
    ev.preventDefault();

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    if (window.location.pathname === "/cart") {
      fetch("/cart")
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const cartContainer = document.querySelector(".cart");
          const cartContainerNew = doc.querySelector(".cart");
          cartContainer.innerHTML = cartContainerNew.innerHTML;
        });
    }
  });

  let manageSubscriptionsButton = document.querySelector(
    ".account__block-item .shopify-app-block .btn"
  );
  let menuList = document.querySelector(".link-bar__linklist");

  console.log("manageSubscriptionsButton", manageSubscriptionsButton);
  console.log("menuList", menuList);

  if (manageSubscriptionsButton && menuList) {
    let links = document.querySelectorAll(".link-bar__link-item");
    let logoutLink = links[links.length - 1];
    let manageSubscriptionsButtonClone =
      manageSubscriptionsButton.cloneNode(true);

    manageSubscriptionsButtonClone.classList.remove("btn");
    manageSubscriptionsButtonClone.classList.remove("btn--small");
    manageSubscriptionsButtonClone.classList.add("link-bar__link");
    manageSubscriptionsButtonClone.classList.add("link--animated");
    manageSubscriptionsButtonClone.classList.add("text--subdued");

    let manageSubscriptionsButtonCloneWrapper = document.createElement("li");
    manageSubscriptionsButtonCloneWrapper.classList.add("link-bar__link-item");
    manageSubscriptionsButtonCloneWrapper.appendChild(
      manageSubscriptionsButtonClone
    );
    menuList.insertBefore(manageSubscriptionsButtonCloneWrapper, logoutLink);

    manageSubscriptionsButton.remove();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let reorderButtons = document.querySelectorAll(
    ".account__order-item__product-buttons button"
  );

  [...reorderButtons].forEach((button) => {
    button.addEventListener("click", (ev) => {
      let variantId = button.getAttribute("data-variant");
      let quantity = button.getAttribute("data-quantity");

      fetch(`/cart/add.js?quantity=${quantity}&id=${variantId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
            })
          );

          document.getElementById("mini-cart").open = true;
        });
    });
  });
});
class VideosList extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const swiperEl = this.classList.contains('swiper') ? this : this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 40,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        741: {
          slidesPerView: 5,
        }
      },
      on: {
          resize: function enableOnlyMobile(swiper){
              if (window.innerWidth <= 740){
                  swiper.enable()
                  swiper.el.classList.remove('non-slider')
              } else {
                swiper.disable()
                swiper.el.classList.add('non-slider')
              }
          },
      }
    });
    console.log("IS THIS WORKING???????");
  }
}
customElements.define("videos-list", VideosList);

class ZestyReviews extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const swiperEl = this.querySelector(".swiper");
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 40,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        800: {
          slidesPerView: 2,
        },
        1300: {
          slidesPerView: 3,
        },
      },
    });
  }
}

// Define the new element
customElements.define("zesty-reviews", ZestyReviews);

class ZestyTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let buttons = this.querySelectorAll(".tabs__button");
    let tabs = this.querySelectorAll(".tabs__tab");

    buttons[0].classList.add("active");
    tabs[0].classList.add("active");

    [...buttons].forEach((button, index) => {
      button.addEventListener("click", () => {
        buttons.forEach((button) => button.classList.remove("active"));
        tabs.forEach((tab) => tab.classList.remove("active"));

        button.classList.add("active");
        tabs[index].classList.add("active");
      });
    });
  }
}

// Define the new element
customElements.define("zesty-tabs", ZestyTabs);

document.addEventListener("DOMContentLoaded", function () {
  let expandButtons = document.querySelectorAll(".text-with-icons__expand");

  expandButtons.forEach((button) => {
    button.addEventListener("click", function () {
      let parent = button.closest(".text-with-icons__content-wrapper");
      let content = parent.querySelector(
        ".text-with-icons__expandable-content"
      );

      if (content.classList.contains("expanded")) {
        content.classList.remove("expanded");
        button.innerHTML = "+ Read More";
      } else {
        content.classList.add("expanded");
        button.innerHTML = "- Read Less";
      }
    });
  });

  let ingredientsSection = document.querySelector(
    ".text-with-icons--ingredients"
  );

  if (ingredientsSection) {
    let count = window.innerWidth < 768 ? 4 : 5;
    let loadMoreButtons = document.querySelectorAll(
      ".shopify-section--text-with-icons .load-more"
    );
    let hiddenItems = ingredientsSection.querySelectorAll(
      ".text-with-icons__item--hidden"
    );
    let moreLoaded = false;

    hiddenItems.forEach((item, index) => {
      if (index < count) {
        item.classList.remove("hidden");
      }
    });

    loadMoreButtons.forEach((button) => {
      button.addEventListener("click", function () {
        if (moreLoaded) {
          hiddenItems.forEach((item, index) => {
            if (index >= count) {
              item.classList.add("hidden");
            }
          });

          button.innerText = "Load less";
          moreLoaded = false;
        } else {
          hiddenItems.forEach((item) => {
            item.classList.remove("hidden");
          });

          button.innerText = "Load less";
          moreLoaded = true;
        }
      });
    });
  }

  /**
   * Smooth scroll to anchor links with data-scroll-to attribute
   * It will scroll to the target element with a header offset of 130px
   */
  document.querySelectorAll("a[data-scroll-to]").forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');
      if (!href || !href.includes('#')) return;
  
      const targetId = href.split('#')[1];
      if (!targetId) return;
  
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;
  
      event.preventDefault();
  
      const headerOffset = 130; 
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    });
  });
});
